import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReciterService {
  currentPage = new BehaviorSubject<String>('');
  currentPageSub = this.currentPage.asObservable();

  constructor(private _http: HttpClient) {}

  // get teacher info
  getReciterInfo(reciterId: string) {
    return this._http.get(
      `${environment.meetApiHost}guests/teachers/${reciterId}`
    );
  }

  // get teacher insights
  getReciterInsights(reciterId: string) {
    return this._http.get(
      `${environment.meetApiHost}guests/teachers-insights/${reciterId}`
    );
  }

  // get teacher reviews
  getReciterReviews(reciterId: string) {
    return this._http.get(
      `${environment.meetApiHost}guests/reviews/${reciterId}`
    );
  }

  // get maqraa details
  getMaqraaDetails(maqraaId: string) {
    return this._http.get(`${environment.meetApiHost}guests/maqraa/${maqraaId}`);
  }

  // get maqraa details by token
  getMaqraaDetailsByToken(maqraaToken: string) {
    return this._http.get(`${environment.meetApiHost}guests/maqraa-by-token/${maqraaToken}`);
  }

  // get course details
  getCourseDetails(courseId: string) {
    return this._http.get(`${environment.meetApiHost}guests/courses/${courseId}`);
  }
}
